// extracted by mini-css-extract-plugin
module.exports = {"container":"PhoneNumberCheckerLayout_container__1PHeo","footerText":"PhoneNumberCheckerLayout_footerText__wzj8l"};